export default __webpack_public_path__ + "static/media/building2.bbc6ff55.png";